import React, { Fragment, useEffect, useRef, useState } from 'react';
import { Grid } from '@mui/material';
import Modal, { ModalBody, ModalFooter } from 'Components/Modal';
import { Button, Form, Input, Select } from 'Components';
import { useIntl } from 'react-intl';

const CreateEditContact = (props) => {
  //Props
  const {
    showModal,
    onCloseModal,
    contact,
    optionsSelect,
    onSubmit,
    loading,
    cellCarriers
  } = props;

  const { messages, locale } = useIntl()

  //Ref
  const serviceFormRef = useRef();

  //Local state
  const [formData, setFormData] = useState({});
  const [dataResult, setDataResult] = useState({type:'email'});
  const [formTypeSelected, setFormTypeSelected] = useState(optionsSelect[0]);
  const [formCellCarrierSelected, setFormCellCarrierSelected] = useState(null);
  const [formEmail, setFormEmail] = useState("");
  const [formCellphone, setFormCellphone] = useState("");

  //Render view
  const initialData = () => {
    //data for inputs
    setFormData(contact);
    //Response data
    setDataResult({
      ...contact,
      type: contact.type.id
    });
    //Data inputs select (Type, Address and Carrier)
    setFormTypeSelected(contact.type);

    if (contact.type.id === "email") {
      setFormEmail(contact.address);
    } else {
      const addressCellphoneCarrier = contact.address.split("@");
      const cellphone = addressCellphoneCarrier[0];
      const carrier = addressCellphoneCarrier[1];
      const resultFilterCarrier = cellCarriers.find((item) => item.gateway === carrier);
      setFormCellCarrierSelected(resultFilterCarrier);
      setFormCellphone(cellphone);
    }
  }
  //If the contact comes with data, it is to update
  useEffect(() => {
    if (contact) {
      initialData();
    }
  }, [contact]);

  //Save the result of each modified data
  useEffect(() => {
    if (formTypeSelected && formData?.title) {
      setDataResult({
        ...dataResult,
        ...formData,
        type: formTypeSelected.id,
      })
    }
  }, [formData, formTypeSelected, locale]);

  //Save to address depending on the type
  useEffect(() => {
    if (formEmail || formCellphone) {
      setDataResult({
        ...dataResult,
        ...formData,
        address: formTypeSelected.id === "email" ?formEmail :formCellphone,
        type: formTypeSelected.id
      });
    }
  }, [formEmail, formCellphone]);

  useEffect(() => {
    if (formCellCarrierSelected) {
      setDataResult({
        ...dataResult,
        address: `${formCellphone}@${formCellCarrierSelected.gateway}`
      });
    }
  }, [formCellphone, formCellCarrierSelected])

  const clearStateLocal = () => {
    setFormData({});
    setDataResult({});
    setFormTypeSelected(optionsSelect[0]);
    setFormCellCarrierSelected(null);
    setFormEmail("");
    setFormCellphone("");
  }

  const renderType = (option) => {
    if (option) {
      if (option.id === "cellphone") {
        //Type phone
        return (
          <>
            <Grid item sm={12}>
              <Input
                id="cellphone"
                type="text"
                label={messages['accountContacts_cellphone']}
                placeholder={messages['accountContacts_cellphone']}
                value={formCellphone}
                onChange={(value) => {
                  setFormCellphone(value)
                }}
                regex={/^\d*$/}
                maxLength={10}
                maxLengthMessage={`${messages["accountContacts_maxLengthMessageCellPhone"]} 10`}
                minLength={10}
                minLengthMessage={`${messages["accountContacts_minLengthMessageCellPhone"]} 10`}
                required
                requiredMessage={messages['required_field']}
              />
            </Grid>
            <Grid item sm={12}>
              <Select
                id="type"
                label={messages['accountContacts_carrier']}
                placeholder={messages['accountContacts_select']}
                valueField="gateway"
                textField="carrier"
                options={cellCarriers}
                value={formCellCarrierSelected}
                onChange={(data) => {
                  setFormCellCarrierSelected(data);
                }}
                isClearable
                required
                requiredMessage={messages['required_field']}
              />
            </Grid>
          </>
        );
      } else {
        //Type email
        return (
          <Grid item sm={12}>
            <Input
              id="address"
              type="email"
              label={messages['accountContacts_address']}
              placeholder={messages['accountContacts_address']}
              value={formEmail}
              onChange={(value) => {
                setFormEmail(value)
              }}
              email
              emailMessage={messages['accountContacts_emailMessage']}
              maxLength={50}
              required
              requiredMessage={messages['required_field']}
            />
          </Grid>);
      }
    }

  }

  return (
    <Fragment>
      <Modal
        title={contact ? `${messages["accountContacts_editContact"]} "${contact.title}"` : messages["accountContacts_newContact"]}
        open={showModal}
        size="small"
        position="right"
        loading={loading}            
        handleClose={() => {
          onCloseModal();
          clearStateLocal();
        }}
      >
        <ModalBody style={{ padding: 25 }}>
          <Form
            ref={serviceFormRef}
            onValidSubmit={() => {
              let result = dataResult
              if(contact?.id){
                result.id = contact?.id
              }

              if(!result?.title){
                result.title = contact.title
              }
              onSubmit(contact ? "update" : "create", result)
              clearStateLocal();
            }}
          >
            <Grid
              container
              justifyContent={'center'}
              direction={'column'}
              className="paddingBody"
              spacing={2}
            >
              <Grid item sm={12}>
                <Input
                  id="title"
                  type="text"
                  label={messages['accountContacts_title']}
                  placeholder={messages['accountContacts_title']}
                  value={formData?.title || ""}
                  onChange={(value) => {
                    setFormData({ ...formData, title: value })
                  }}
                  maxLength={51}
                  maxLengthMessage={`${messages['accountContacts_maxLengthMessagetitle']} 50`}
                  required
                  requiredMessage={messages['required_field']}
                />
              </Grid>
              <Grid item sm={12}>
                <Select
                  id="type"
                  label={messages['accountContacts_type']}
                  placeholder={messages['accountContacts_select']}
                  valueField="id"
                  textField="name"
                  options={optionsSelect}
                  value={formTypeSelected}
                  onChange={(data) => {
                    setFormTypeSelected(data)
                  }}
                  isClearable
                  required
                  requiredMessage={messages['required_field']}
                />
              </Grid>
              {renderType(formTypeSelected)}
            </Grid>
          </Form>
        </ModalBody>
        <ModalFooter>
          <Button
            onClick={() => {
              onCloseModal();
              clearStateLocal();
            }}
            className="btn-cancel"
          >
            {messages["accountContacts_cancel"]}
          </Button>
          <Button
            className="btn-blue"
            onClick={(e) => {
              e.preventDefault();
              serviceFormRef.current.submit();
            }}
          >
            {contact ? messages["accountContacts_edit"] : messages["accountContacts_add"]}
          </Button>
        </ModalFooter>
      </Modal>
    </Fragment>
  );
}

export default CreateEditContact;